export * from './projectCustomers.service';
import { ProjectCustomersService } from './projectCustomers.service';
export * from './projectCustomers.serviceInterface';
export const APIS = [ProjectCustomersService];
